import { IConfigFunctionArgs } from 'Components/Equipment/Core';
import * as oPath from '../../../../Lib/Object/Path/Immutable';

const UNITS_METRIC = 'Metric';

const getConfig = (prefix: string) => ({
  [`${prefix}.FaceDiameter`]: (configArgs: IConfigFunctionArgs) => {
    const units = oPath.get(configArgs.equipment, `${prefix}.NominalUnits`);
    return {
      format: units === UNITS_METRIC ? { nearest: 0.01 } : { nearest: 0.001 },
      uom: units === UNITS_METRIC ? 'mm' : 'in',
    };
  },
  [`${prefix}.FaceRadius`]: (configArgs: IConfigFunctionArgs) => {
    const units = oPath.get(configArgs.equipment, `${prefix}.NominalUnits`);
    return {
      format: units === UNITS_METRIC ? { nearest: 0.01 } : { nearest: 0.001 },
      uom: units === UNITS_METRIC ? 'mm' : 'in',
    };
  },
});

export { getConfig };

export default {
  30003: getConfig('data'),
};
